import {
  CollaboratorListItem,
  CollaboratorListResponse,
  FilterOptions
} from './collaborator-service-types'

/**
 * Welcome-email eligibility.
 *
 * The welcome email is only meant for users who haven't completed their first
 * access yet AND whose account is active. Users who already onboarded
 * (onboardingComplete=true) or were deactivated (active=0) must be excluded —
 * the "resend access" flow handles them separately.
 *
 * The OLD backoffice is supposed to apply this filter server-side but does not,
 * so we enforce it client-side to keep the recipient list (and the count shown
 * to the user) honest.
 */
export const isWelcomeEligible = (collaborator: CollaboratorListItem): boolean =>
  collaborator.onboardingComplete === false && collaborator.active === 1

/**
 * Format collaborator list response from OLD backoffice API
 * OLD: {results: [], pages: 10}
 */
export const formatCollaboratorList = (
  response: CollaboratorListResponse
): CollaboratorListResponse => ({
  results: response.results || [],
  pages: response.pages || 1,
  total: response.total
})

/**
 * Format filter options from OLD backoffice API
 * GET /api/management/options
 */
export const formatFilterOptions = (response: FilterOptions | undefined | null): FilterOptions => ({
  companies: response?.companies || [],
  departments: response?.departments || [],
  jobs: response?.jobs || [],
  accountTypes: response?.accountTypes || [],
  typegroup: response?.typegroup || []
})

/**
 * Build comma+space separated string for OLD API
 * Example: [1, 2, 3] => "1, 2, 3"
 */
export const buildCommaSeparatedString = (items: Array<{ value: number | string }>): string =>
  items?.map(item => item.value).join(', ') || ''
